// The best price any bookmaker offers for a team selection, with that bookmaker's name: the
// same prices the bet slip uses (betslip service, selections.team_leg). The feed sends odds as
// strings ("1.61"), so they are coerced here.

const SIDE_KEYS = { home: "home_team", draw: "draw", away: "away_team" };
// the card's own goal markets (`markets`) are bet365's prices
const MARKET_BOOKMAKER = "bet365";

function best(...prices) {
  let top = null;
  for (const [odds, bookmaker] of prices) {
    const n = Number(odds);
    if (n > 1 && (!top || n > top.odds)) top = { odds: n, bookmaker: bookmaker || null };
  }
  return top;
}

// home / draw / away: {odds, bookmaker} or null
export function bestResultPrice(card, subject) {
  const block = card && card[SIDE_KEYS[subject]];
  if (!block) return null;
  return best(
    [block.best_odds, block.bookmaker],
    ...(block.odds || []).map((row) => [row.odds, row.bookie]),
  );
}

// "btts" / "ou_2_5" with "yes" / "no" / "over" / "under": {odds, bookmaker} or null
export function bestGoalPrice(card, key, subject) {
  const own = (((card && card.markets) || {})[key] || {})[subject] || {};
  const other = (((card && card.best_prices) || {})[key] || {})[subject] || {};
  return best([own.odds, MARKET_BOOKMAKER], [other.odds, other.bookmaker]);
}
